import { API2_HOST } from '../../helpers/urlHelper';
import {
  baseSearch,
  basePost,
  basePatch,
  baseGet
} from 'services/base-services/baseService';
import axios from 'axios';
axios.defaults.withCredentials = true;

const baseURL = `${API2_HOST}/bs-kpi-boards`;
const search = async request => {
  return await baseSearch(baseURL, request);
};

const post = async request => {
  return await basePost(baseURL, request);
};

const patch = async (id, request) => {
  return await basePatch(baseURL, request, id);
};
const get = async (id) => {
  return await baseGet(baseURL, id);
};
export { search, post, patch, get };
